import { useInvoiceCollectionNotesData } from './useInvoiceCollectionNotesData';
import { InvoiceCollectionNotesTable } from './InvoiceCollectionNotesTable';

const InvoiceCollectionNotesReports = () => {
  const { rows, isLoading } = useInvoiceCollectionNotesData();

  return (
    <div className="flex flex-col w-full h-full pt-4">
      <InvoiceCollectionNotesTable data={rows} isLoading={isLoading} />
    </div>
  );
};

export default InvoiceCollectionNotesReports;
